const getters = {
    employeeTrainings: (state) => state.employeeTrainings,
    employeeTrainingId: (state) => state.employeeTrainingId,
    loading: state => state.loading
};

export default getters;